import { Military, Optom, TermoSocks, WarmSocks, WarmSocksSubCategory } from "./logic/const/constants";


export function initializePrice(product) {
    switch (product.subCategory) {
        case TermoSocks: return ` грн/${product.pars} пар`;
        case WarmSocksSubCategory: return ` грн/${product.pars} пар`;
        case Military: return ` грн/${product.pars} пар`;
        case Optom: return ` грн/${product.pars} пар`;
        default: return " грн/комплект"
    }
}